import { MrbBaseEditViewStore } from "mrb/core";
import { LoadioContentProfileEditForm } from "administration/loadio/forms";
import { makeObservable } from "mobx";

class LoadioContentProfileEditViewStore extends MrbBaseEditViewStore {
    constructor(rootStore, { routeStore }) {
        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            id: id,
            name: "loadio-content-profile",
            FormClass: LoadioContentProfileEditForm,
            autoFocusField: "name",
            navigateBack: "master.administration.loadio-dashboard.profile.list",
            successCreateNotification: null,
            successUpdateNotification: null,
            redirectOnCreateSuccess: (result) =>
                rootStore.routerStore.goTo(
                    "master.administration.loadio-dashboard.profile.artists",
                    { id: result.id }
                ),
        });
        makeObservable(this);
        this.routeStore = routeStore;
    }

    get(id) {
        return this.routeStore.getProfile(id);
    }

    setItem(item) {
        super.setItem(item);
        if (item && item.timeStamp !== undefined) {
            this.form.$("timeStamp").set(item.timeStamp);
        }
    }

    create(data) {
        delete data.timeStamp;
        return this.routeStore.createProfile(data);
    }

    update(data) {
        return this.routeStore.updateProfile(data);
    }

    onCreateError(err) {
        if (err && err.statusCode === 409) {
            this.rootStore.notificationStore.error("A content profile with this name already exists.", err);
        } else {
            this.rootStore.notificationStore.error(
                "An unexpected error occurred while trying to create content profile.",
                err
            );
        }
    }

    onUpdateError(err) {
        if (err && err.statusCode === 409) {
            this.rootStore.notificationStore.error("A content profile with this name already exists.", err);
        } else {
            this.rootStore.notificationStore.error(
                "An unexpected error occurred while trying to update content profile.",
                err
            );
        }
    }
}

export default LoadioContentProfileEditViewStore;
